/**
 * HM-400 cluster 17 Planning Gantt: modal conferma drop drag&drop.
 *
 * Mostra il diff "prima -> dopo" (camera + start) e attende Conferma o Annulla
 * dell'utente prima di triggerare la mutation PATCH /bookings/:id/reschedule.
 */
import type { PlanningItem } from '../../api/planning.js';

function formatItalianDateTime(iso: string): string {
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm} ${hh}:${min}`;
}

export function RescheduleConfirmModal({
  booking,
  newRoomCode,
  newStartAtIso,
  newEndAtIso,
  pending,
  onConfirm,
  onCancel,
}: {
  booking: PlanningItem;
  newRoomCode: string;
  newStartAtIso: string;
  newEndAtIso: string;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const oldRoomCode = booking.roomCode ?? '—';
  const guestName = booking.guestName ?? `Walk-in ${booking.publicCode}`;

  return (
    <div
      className="planning-modal-overlay"
      // biome-ignore lint/a11y/useSemanticElements: vedi BookingDetailDrawer per la motivazione (overlay div semplice).
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onCancel();
      }}
      data-testid="reschedule-confirm-modal"
    >
      <div className="planning-modal">
        <div className="planning-modal-title">Conferma spostamento</div>
        <div className="planning-modal-body">
          <p>
            Vuoi davvero spostare la prenotazione di <strong>{guestName}</strong>?
          </p>
          <p style={{ marginTop: 10, fontSize: 13, color: '#7A6957' }}>
            <strong>Da:</strong> Camera {oldRoomCode} · {formatItalianDateTime(booking.startAt)}
            <br />
            <strong>A:</strong> Camera {newRoomCode} · {formatItalianDateTime(newStartAtIso)}
          </p>
          <p style={{ marginTop: 8, fontSize: 12, color: '#A89A88' }}>
            Durata invariata fino a {formatItalianDateTime(newEndAtIso)}.
          </p>
        </div>
        <div className="planning-modal-actions">
          <button
            type="button"
            className="planning-drawer-btn"
            onClick={onCancel}
            disabled={pending}
            data-testid="reschedule-cancel"
          >
            Annulla
          </button>
          <button
            type="button"
            className="planning-drawer-btn primary"
            onClick={onConfirm}
            disabled={pending}
            data-testid="reschedule-confirm"
          >
            {pending ? 'Sposto…' : 'Conferma'}
          </button>
        </div>
      </div>
    </div>
  );
}
